// extracted by mini-css-extract-plugin
export var attachment = "_ij-a";
export var emailContainer = "_ij-4";
export var emailContentPaddedContainer = "_ij-b";
export var emailHeader = "_ij-6";
export var emailIframe = "_ij-3";
export var emailInfoIcon = "_ij-9";
export var emailShortenedSummary = "_ij-e";
export var infoDropdown = "_ij-0";
export var infoRowBoundedContent = "_ij-d";
export var internal = "_ij-5";
export var merchant = "_ij-8";
export var messageInputContainer = "_ij-h";
export var normal = "_ij-7";
export var replyCard = "_ij-f";
export var subtleButton = "_ij-1";
export var subtleButtonIconContainer = "_ij-2";
export var toggleViewRepliesButton = "_ij-c";
export var wrappingText = "_ij-g";